import _debounce from "lodash/debounce";
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { NO_DESIGN_POPUP, LOGIN_POPUP, LOGIN_FOR_FAVOURITES_TITLE } from 'swag-client-common/constants';
import { toggleFavouriteProduct } from 'swag-client-common/redux/favourite-products/favourite-products.actions';
import { saveDesign, startSharingDesign, placeProductToStore, changeOpenedToolbarItem, toggleForceHideToolbar } from '../../../../../../../redux/product/product.actions';
import { toolbarConvertToColor } from '../../../../../../../redux/logo-editing/logo-editing.actions';
export const toolsPanelDispatcher = (dispatch, props) => {
  const debouncedDispatch = _debounce(dispatch, 1000);
  return {
    onClickShareDesign: () => {
      dispatch(startSharingDesign());
    },
    onClickAddToStore: () => {
      dispatch(placeProductToStore());
    },
    onDesignSave: () => {
      dispatch(saveDesign());
    },
    onShowWarningNoImage: () => {
      dispatch(showPopup({
        popup: NO_DESIGN_POPUP
      }));
    },
    onClickConvertToOneColor: () => {
      dispatch(toolbarConvertToColor());
    },
    changeOpenedToolbarItem: value => {
      dispatch(changeOpenedToolbarItem(value));
    },
    toggleForceHideToolbar: value => {
      dispatch(changeOpenedToolbarItem(null));
      dispatch(toggleForceHideToolbar(value));
    },
    onProductFavouriteClick: ({
      productId,
      nextIsFavourite
    }) => {
      if (props.isLoggedIn) {
        debouncedDispatch(
        // @ts-ignore
        toggleFavouriteProduct({
          productId,
          nextIsFavourite
        }));
      } else {
        dispatch(showPopup({
          popup: LOGIN_POPUP,
          title: LOGIN_FOR_FAVOURITES_TITLE
        }));
      }
    }
  };
};